import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { generateTransactionID } from "../operationTypeCustomerDetails/OperationType";
import { uiAlert } from "../../../../components/alerts/customAlert/uiAlert";
import { createBookingOrderUrl } from "../../../../api/endpoints";
import { NIGERIAN_BANKS } from "../../../payouts/Banktransfer";

const BookingOverlay = ({ showBooking, setShowBooking, currency, cartItems, customer, discount, onRegistrationComplete }) => {
  /*  const [showBooking, setShowBooking] = useState(false); */
  const [bookingData, setBookingData] = useState({
    customerID: "",
    customerName: "",
    customerEmail: "",
    customerPhone: "",
    comment: "",
    discount: 0,
    vatPercentage: 0,
    bankAccountNumber: "",
    bankName: "",
  });
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [orderItems, setOrderItems] = useState([
    { name: "Premium Wireless Headphones", price: 45000, quantity: 2 },
    { name: "Smart Watch Series 5", price: 125000, quantity: 1 },
    { name: "Phone Case - Leather", price: 5000, quantity: 3 },
  ]);

  const { store } = useSelector((state) => state.store);
  const { user } = useSelector((state) => state.webStoreUser);

  console.log("cartItems", cartItems, customer, discount);

  useEffect(() => {
    if (customer) {
      setBookingData((prev) => ({
        ...prev,
        customerID: customer.customerID || "",
        customerName: customer.name || "",
        customerEmail: customer.email || "",
        customerPhone: customer.phoneNumber || "",
      }));
    }
    if (cartItems && cartItems.length > 0) {
      const items = cartItems.map((item) => ({
        id: item.isSubUnitSold ? item.productId : item._id,
        name: item.name,
        brand: item.brand,
        isSubUnitSold: item.isSubUnitSold ? true : false,
        category: item.productCategory,
        unit: item.unit,
        subUnitId: item.subUnitId ? item.subUnitId : null,
        serialNumber: item.serialNumber ? item.serialNumber : null,
        productCostPrice: item.costPrice,
        soldUnitPrice: item.soldUnitPrice,

        price: item.soldUnitPrice,
        quantity: item.soldQuantity,
        inStock: Number(item.quantity) - Number(item?.damagedAmount || 0),

        productImage: item.productImage[0],
      }));
      console.log("Transformed order items:", items);

      setOrderItems(items);
    }
    if (discount) {
      setBookingData((prev) => ({
        ...prev,
        discount: discount,
      }));
    }
  }, []);

  const subtotal = orderItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
  const discountAmount = Number(bookingData.discount) || 0;
  const vatAmount = (subtotal * (Number(bookingData.vatPercentage) || 0)) / 100;
  const finalTotal = subtotal - discountAmount + vatAmount;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBookingData((prev) => ({ ...prev, [name]: value }));
  };

  const handleQuantityChange = (index, newQuantity, stockQty) => {
    const qty = Math.max(1, Math.min(stockQty, Number(newQuantity) || 1));
    setOrderItems((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], quantity: qty };
      return updated;
    });
  };

  const isFormValid = () => {
    return bookingData.customerName && bookingData.customerPhone && bookingData.bankAccountNumber && bookingData.bankName;
  };
  console.log(store.storeName);

  const generateBookingMessage = (bookedOrderID, orderUrl) => {
    console.log("orderUrl", orderUrl);

    const itemsList = orderItems
      .map(
        (item) => `• ${item.name}\n  ${currency}${item.price.toLocaleString()} × ${item.quantity} = ${currency}${(item.price * item.quantity).toLocaleString()}`
      )
      .join("\n\n");

    let message = `🛍️ *ORDER BOOKING - from ${store.storeName} *\n\n`;
    message += `*CUSTOMER DETAILS:*\nName: ${bookingData.customerName}\n`;
    if (bookingData.customerEmail) message += `Email: ${bookingData.customerEmail}\n`;
    message += `Phone: ${bookingData.customerPhone}\n\n`;
    message += `*ORDER ITEMS:*\n${itemsList}\n\n`;
    message += `*ORDER SUMMARY:*\nSubtotal: ${currency}${subtotal.toLocaleString()}\n`;
    if (discountAmount > 0) message += `Discount: -${currency}${discountAmount.toLocaleString()}\n`;
    if (vatAmount > 0) message += `VAT (${bookingData.vatPercentage}%): +${currency}${vatAmount.toLocaleString()}\n`;
    message += `*Total Amount: ${currency}${finalTotal.toLocaleString()}*\n\n`;
    message += `*PAYMENT DETAILS:*\nBank: ${bookingData.bankName}\nAccount: ${bookingData.bankAccountNumber}\n\n`;
    if (bookingData.comment) message += `*NOTE:*\n${bookingData.comment}\n\n`;
    message += `*BOOKED ORDER ID:* ${bookedOrderID}\n`;
    message += `You can view your booked order details here: ${orderUrl}\n\n`;

    message += `Please transfer the amount to the account above.\nThank you! 🎉 \n Best regards`;
    message += `\n${store.storeName} Team`;
    message += `\n${user.phoneNumber ? `Contact: ${user.phoneNumber}` : ""}`;

    return message;
  };

  const shareOnWhatsApp = () => {
    const bookedOrderID = generateTransactionID();
    const orderUrl = `https://storelense.com/bookedOrders/?storeID=${store._id}&&orderID=${bookedOrderID}  `; // order URL
    if (!isFormValid()) return;
    const message = encodeURIComponent(generateBookingMessage(bookedOrderID, orderUrl));
    const phoneNumber = bookingData.customerPhone.replace(/\D/g, "");
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
    // setShowConfirmation(true);
    registerbookedOrder(bookedOrderID, orderUrl, "whatsapp");
  };

  const sendToEmail = () => {
    const bookedOrderID = generateTransactionID();
    const orderUrl = `https://storelense.com/bookedOrders/?storeID=${store._id}&&orderID=${bookedOrderID}  `; // order URL

    if (!isFormValid()) return;
    const subject = encodeURIComponent("Your Order Booking - StoreLense");
    const body = encodeURIComponent(generateBookingMessage(bookedOrderID, orderUrl));
    window.location.href = `mailto:${bookingData.customerEmail}?subject=${subject}&body=${body}`;
    registerbookedOrder(bookedOrderID, orderUrl, "email");
    // setShowConfirmation(true);
  };
  const normalizeVat = (value) => {
    if (value == null || value === "") return null;
    return String(Number(value)); // "07.5" → "7.5"
  };

  const registerbookedOrder = async (bookingOrderID, orderUrl, sentVia) => {
    const payload = {
      bookedOrderDetails: {
        date: new Date(),
        paymentMode: "bankTransfer",
        numberOfItems: orderItems.length,
        subTotal: subtotal,
        totalAmount: finalTotal,
        discount: discountAmount,
        vat: vatAmount,
        vatPercentage: normalizeVat(bookingData.vatPercentage),
      },
      currency: currency,
      paymentDetails: {
        bankName: bookingData.bankName,
        accountNumber: bookingData.bankAccountNumber,
      },
      bookedBy: "Admin",
      customer: {
        customerID: bookingData.customerID == null || bookingData.customerID.trim?.() === "" ? null : bookingData.customerID,
        fullName: bookingData.customerName,
        email: bookingData.customerEmail,
        phoneNumber: bookingData.customerPhone,
      },
      webstoreUserID: user ? user._id : null,
      webstoreUserPhoneNumber: user ? user.phoneNumber : null,
      url: orderUrl,
      sentVia,
      store: {
        id: store._id,
        name: store.storeName,
      },

      products: orderItems.map((item) => ({
        id: item.id,
        name: item.name,
        productImage: item.productImage,
        category: item.category,
        productCostPrice: item.productCostPrice,
        soldUnitPrice: item.price,
        quantity: item.quantity,
        serialNumber: item.serialNumber,
        unit: item.unit,
        isSubUnitSold: item.isSubUnitSold,
        subUnitId: item.subUnitId,
        totalAmount: Number(item.price) * Number(item.quantity),
      })),
      status: "pending",
      comments: bookingData.comment,
      bookedOrderID: bookingOrderID,
    };

    const accessToken = localStorage.getItem("accessToken");
    try {
      let response = await fetch(createBookingOrderUrl + store._id, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log("Booked order registered:", data);

      uiAlert("Booked order registered successfully!", "success");
      onRegistrationComplete();
      setShowConfirmation(true);
    } catch (error) {
      console.error("Error registering booked order:", error);
      uiAlert("Failed to register booked order. Please try again.", "error");
    }
  };

  const resetDemo = () => {
    setShowBooking(false);
    setShowConfirmation(false);
    setBookingData({
      customerName: "",
      customerEmail: "",
      customerPhone: "",
      comment: "",
      discount: 0,
      vatPercentage: 0,
      bankAccountNumber: "",
      bankName: "",
    });
    setOrderItems([
      { name: "Premium Wireless Headphones", price: 45000, quantity: 2 },
      { name: "Smart Watch Series 5", price: 125000, quantity: 1 },
      { name: "Phone Case - Leather", price: 5000, quantity: 3 },
    ]);
  };

  const allowDigits = (e) => {
    if (e.inputType?.startsWith("insert") && e.data && /[^0-9]/.test(e.data)) {
      e.preventDefault();
    }
  };
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
        padding: "40px 20px",
      }}
    >
      {/* Booking Overlay */}
      {showBooking && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
            display: "flex",
            alignItems: window.innerWidth <= 800 ? "flex-end" : "center",
            justifyContent: "center",
            padding: window.innerWidth <= 800 ? "0" : "20px",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(0, 0, 0, 0.5)",
              backdropFilter: "blur(4px)",
            }}
            onClick={() => setShowBooking(false)}
          />

          <div
            style={{
              position: "relative",
              background: "#ffffff",
              borderRadius: window.innerWidth <= 800 ? "20px 20px 0 0" : "16px",
              width: "100%",
              maxWidth: window.innerWidth <= 800 ? "100%" : "1100px",
              maxHeight: window.innerWidth <= 800 ? "96vh" : "92vh",
              overflow: "hidden",
              boxShadow: window.innerWidth <= 800 ? "0 -10px 25px -5px rgba(0, 0, 0, 0.1)" : "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {!showConfirmation ? (
              <>
                {/* Header */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: window.innerWidth <= 800 ? "16px" : "20px 28px",
                    borderBottom: "1px solid #e5e7eb",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <div
                      style={{
                        width: "32px",
                        height: "32px",
                        background: "linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)",
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#3b82f6",
                      }}
                    >
                      📦
                    </div>
                    <div>
                      <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#111827", margin: 0 }}>Book Order</h2>
                      <p style={{ fontSize: "13px", color: "#6b7280", margin: "2px 0 0 0" }}>Complete the order details below</p>
                    </div>
                  </div>
                  <button
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "8px",
                      border: "none",
                      background: "transparent",
                      color: "#6b7280",
                      cursor: "pointer",
                      fontSize: "20px",
                    }}
                    onClick={() => setShowBooking(false)}
                  >
                    ✕
                  </button>
                </div>

                {/* Content */}
                <div
                  style={{
                    flex: 1,
                    overflowY: "auto",
                    background: "#f9fafb",
                  }}
                >
                  <div
                    style={{
                      display: window.innerWidth <= 800 ? "block" : "grid",
                      gridTemplateColumns: window.innerWidth <= 800 ? "1fr" : "1fr 1fr",
                      minHeight: "100%",
                    }}
                  >
                    {/* Left Column - Order Items & Payment (shows second on mobile) */}
                    <div
                      style={{
                        padding: window.innerWidth <= 800 ? "16px" : "24px",
                        background: "#ffffff",
                        borderRight: window.innerWidth <= 800 ? "none" : "1px solid #e5e7eb",
                        order: window.innerWidth <= 800 ? 2 : 1,
                      }}
                    >
                      {/* Order Items */}
                      <div style={{ marginBottom: "24px" }}>
                        <h3
                          style={{
                            fontSize: "15px",
                            fontWeight: "600",
                            color: "#111827",
                            margin: "0 0 16px 0",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          📦 Order Items ({orderItems.length})
                        </h3>

                        <div
                          style={{
                            maxHeight: window.innerWidth <= 800 ? "none" : "220px",
                            overflowY: window.innerWidth <= 800 ? "visible" : "auto",
                            background: window.innerWidth <= 800 ? "transparent" : "#f9fafb",
                            borderRadius: window.innerWidth <= 800 ? "0" : "12px",
                            padding: window.innerWidth <= 800 ? "0" : "12px",
                          }}
                        >
                          {orderItems.map((item, index) => (
                            <div
                              key={index}
                              style={{
                                background: window.innerWidth <= 800 ? "#f9fafb" : "#ffffff",
                                borderRadius: "8px",
                                padding: "12px",
                                marginBottom: "8px",
                                border: window.innerWidth <= 800 ? "none" : "1px solid #e5e7eb",
                              }}
                            >
                              <div style={{ marginBottom: "8px" }}>
                                <h4 style={{ fontSize: "14px", fontWeight: "600", color: "#111827", margin: "0 0 2px 0" }}>{item.name}</h4>
                                <p style={{ fontSize: "13px", color: "#6b7280", margin: 0 }}>
                                  {currency}
                                  {item.price?.toLocaleString()}
                                </p>
                              </div>
                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                  <button
                                    style={{
                                      width: "28px",
                                      height: "28px",
                                      borderRadius: "6px",
                                      border: "1px solid #d1d5db",
                                      background: "#ffffff",
                                      cursor: "pointer",
                                      fontSize: "16px",
                                    }}
                                    onClick={() => handleQuantityChange(index, item.quantity - 1, item.inStock)}
                                  >
                                    −
                                  </button>
                                  <input
                                    key={isMobile ? "mobile" : "desktop"}
                                    type={"text"}
                                    inputMode='numeric' // shows numeric keyboard on mobile
                                    pattern={isMobile ? "[0-9]*" : undefined}
                                    onBeforeInput={isMobile ? allowDigits : undefined}
                                    value={item.quantity}
                                    onChange={(e) => {
                                      const rawValue = e.target.value;

                                      if (Number(rawValue) > item.inStock) {
                                        handleQuantityChange(index, item.inStock, item.inStock);
                                        return;
                                      }

                                      // Example: allow only numbers
                                      if (!/^\d*$/.test(rawValue)) {
                                        return;
                                      }

                                      handleQuantityChange(index, e.target.value, item.inStock);
                                    }}
                                    style={{
                                      minWidth: "45px",
                                      width: "24%",
                                      maxWidth: "60%",
                                      padding: "4px 8px",
                                      border: "1px solid #d1d5db",
                                      borderRadius: "6px",
                                      fontSize: "14px",
                                      textAlign: "center",
                                      outline: "none",
                                      transition: "border-color 0.2s ease",
                                    }}
                                    onFocus={(e) => (e.target.style.borderColor = "#60a5fa")}
                                    onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
                                  />
                                  <button
                                    style={{
                                      width: "28px",
                                      height: "28px",
                                      borderRadius: "6px",
                                      border: "1px solid #d1d5db",
                                      background: "#ffffff",
                                      cursor: "pointer",
                                      fontSize: "16px",
                                    }}
                                    onClick={() => handleQuantityChange(index, item.quantity + 1, item.inStock)}
                                  >
                                    +
                                  </button>
                                </div>
                                <div style={{ fontSize: "16px", fontWeight: "700", color: "#111827" }}>
                                  {currency}
                                  {(item.price * item.quantity)?.toLocaleString()}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Summary */}
                      <div style={{ marginBottom: "24px" }}>
                        <div
                          style={{
                            background: window.innerWidth <= 800 ? "transparent" : "#f9fafb",
                            borderRadius: window.innerWidth <= 800 ? "0" : "12px",
                            padding: window.innerWidth <= 800 ? "0" : "16px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              padding: "10px 0",
                              fontSize: "14px",
                            }}
                          >
                            <span style={{ color: "#6b7280" }}>Subtotal</span>
                            <span style={{ fontWeight: "600" }}>
                              {currency}
                              {subtotal?.toLocaleString()}
                            </span>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              padding: "10px 0",
                              fontSize: "14px",
                            }}
                          >
                            <span style={{ color: "#6b7280" }}>Discount ({currency})</span>
                            <input
                              key={isMobile ? "mobile" : "desktop"}
                              type={"text"}
                              inputMode='numeric' // shows numeric keyboard on mobile
                              pattern={isMobile ? "[0-9]*" : undefined}
                              onBeforeInput={isMobile ? allowDigits : undefined}
                              name='discount'
                              value={bookingData.discount}
                              onChange={(e) => {
                                const rawValue = e.target.value;
                                // Example: allow only numbers
                                if (!/^\d*$/.test(rawValue)) {
                                  return;
                                }

                                handleInputChange(e);
                              }}
                              placeholder='0'
                              style={{
                                width: "100px",
                                padding: "6px 10px",
                                border: "1px solid #d1d5db",
                                borderRadius: "6px",
                                fontSize: "14px",
                                textAlign: "right",
                                outline: "none",
                                transition: "border-color 0.2s ease",
                              }}
                              onFocus={(e) => (e.target.style.borderColor = "#60a5fa")}
                              onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
                            />
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              padding: "10px 0",
                              fontSize: "14px",
                              alignItems: "center",
                            }}
                          >
                            <span style={{ color: "#6b7280" }}>VAT (%)</span>
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <input
                                type='number'
                                name='vatPercentage'
                                inputMode='numeric' // shows numeric keyboard on mobile
                                pattern={isMobile ? "[0-9]*" : undefined}
                                onBeforeInput={isMobile ? allowDigits : undefined}
                                value={bookingData.vatPercentage}
                                onChange={(e) => {
                                  const rawValue = e.target.value;
                                  // Example: allow only numbers
                                  // if (!/^\d*$/.test(rawValue)) {
                                  //   return;
                                  //  }
                                  if (Number(rawValue) > 100) {
                                    handleInputChange({ target: { name: "vatPercentage", value: 100 } });
                                    return;
                                  }
                                  handleInputChange(e);
                                }}
                                placeholder='0'
                                min='0'
                                max='100'
                                style={{
                                  width: "80px",
                                  padding: "6px 10px",
                                  border: "1px solid #d1d5db",
                                  borderRadius: "6px",
                                  fontSize: "14px",
                                  textAlign: "right",
                                  outline: "none",
                                  transition: "border-color 0.2s ease",
                                }}
                                onFocus={(e) => (e.target.style.borderColor = "#60a5fa")}
                                onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
                              />
                              {vatAmount > 0 && (
                                <span style={{ fontSize: "13px", color: "#10b981", fontWeight: "600", whiteSpace: "nowrap" }}>
                                  +{currency}
                                  {vatAmount?.toLocaleString()}
                                </span>
                              )}
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              padding: "12px 0 0 0",
                              marginTop: "8px",
                              borderTop: "2px solid #e5e7eb",
                            }}
                          >
                            <span style={{ fontSize: "16px", fontWeight: "700" }}>Total</span>
                            <span style={{ fontSize: "24px", fontWeight: "700", color: "#3b82f6" }}>
                              {currency}
                              {finalTotal?.toLocaleString()}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Payment Details */}
                      <div>
                        <h3
                          style={{
                            fontSize: "15px",
                            fontWeight: "600",
                            color: "#111827",
                            margin: "0 0 16px 0",
                          }}
                        >
                          💳 Payment Details
                        </h3>
                        <div style={{ marginBottom: "16px" }}>
                          <label
                            style={{
                              fontSize: "13px",
                              fontWeight: "600",
                              color: "#374151",
                              marginBottom: "6px",
                              display: "block",
                            }}
                          >
                            Bank Name
                          </label>
                          <select
                            name='bankName'
                            value={bookingData.bankName}
                            onChange={handleInputChange}
                            style={{
                              width: "100%",
                              padding: "10px 12px",
                              border: "1px solid #d1d5db",
                              borderRadius: "8px",
                              fontSize: "14px",
                              boxSizing: "border-box",
                              outline: "none",
                              transition: "border-color 0.2s ease",
                            }}
                            onFocus={(e) => (e.target.style.borderColor = "#60a5fa")}
                            onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
                          >
                            <option value='' disabled selected hidden>
                              {" "}
                              Select bank
                            </option>
                            {NIGERIAN_BANKS.map((bank, i) => (
                              <option key={i} value={bank.name}>
                                {bank.name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div>
                          <label
                            style={{
                              fontSize: "13px",
                              fontWeight: "600",
                              color: "#374151",
                              marginBottom: "6px",
                              display: "block",
                            }}
                          >
                            Account Number
                          </label>
                          <input
                            type='text'
                            name='bankAccountNumber'
                            value={bookingData.bankAccountNumber}
                            onChange={handleInputChange}
                            placeholder='Enter account number'
                            maxLength='10'
                            style={{
                              width: "100%",
                              padding: "10px 12px",
                              border: "1px solid #d1d5db",
                              borderRadius: "8px",
                              fontSize: "14px",
                              boxSizing: "border-box",
                              outline: "none",
                              transition: "border-color 0.2s ease",
                            }}
                            onFocus={(e) => (e.target.style.borderColor = "#60a5fa")}
                            onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
                          />
                        </div>
                      </div>
                    </div>

                    {/* Right Column - Customer Details (shows first on mobile) */}
                    <div
                      style={{
                        padding: window.innerWidth <= 800 ? "16px" : "24px",
                        background: window.innerWidth <= 800 ? "#ffffff" : "#f9fafb",
                        order: window.innerWidth <= 800 ? 1 : 2,
                      }}
                    >
                      <h3
                        style={{
                          fontSize: "15px",
                          fontWeight: "600",
                          color: "#111827",
                          margin: "0 0 16px 0",
                        }}
                      >
                        👤 Customer Details
                      </h3>

                      <div style={{ marginBottom: "14px" }}>
                        <label
                          style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "#374151",
                            marginBottom: "6px",
                            display: "block",
                          }}
                        >
                          Full Name *
                        </label>
                        <input
                          type='text'
                          name='customerName'
                          value={bookingData.customerName}
                          onChange={handleInputChange}
                          placeholder='Customer name'
                          style={{
                            width: "100%",
                            padding: "10px 12px",
                            border: "1px solid #d1d5db",
                            borderRadius: "8px",
                            fontSize: "14px",
                            boxSizing: "border-box",
                            background: "#ffffff",
                            outline: "none",
                            transition: "border-color 0.2s ease",
                          }}
                          onFocus={(e) => (e.target.style.borderColor = "#60a5fa")}
                          onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
                        />
                      </div>

                      <div style={{ marginBottom: "14px" }}>
                        <label
                          style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "#374151",
                            marginBottom: "6px",
                            display: "block",
                          }}
                        >
                          Email Address *
                        </label>
                        <input
                          type='email'
                          name='customerEmail'
                          value={bookingData.customerEmail}
                          onChange={handleInputChange}
                          placeholder='customer@email.com'
                          style={{
                            width: "100%",
                            padding: "10px 12px",
                            border: "1px solid #d1d5db",
                            borderRadius: "8px",
                            fontSize: "14px",
                            boxSizing: "border-box",
                            background: "#ffffff",
                            outline: "none",
                            transition: "border-color 0.2s ease",
                          }}
                          onFocus={(e) => (e.target.style.borderColor = "#60a5fa")}
                          onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
                        />
                      </div>

                      <div style={{ marginBottom: "14px" }}>
                        <label
                          style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "#374151",
                            marginBottom: "6px",
                            display: "block",
                          }}
                        >
                          Phone Number *
                        </label>
                        <input
                          type='tel'
                          name='customerPhone'
                          value={bookingData.customerPhone}
                          onChange={handleInputChange}
                          placeholder='+1 234 567 8900'
                          style={{
                            width: "100%",
                            padding: "10px 12px",
                            border: "1px solid #d1d5db",
                            borderRadius: "8px",
                            fontSize: "14px",
                            boxSizing: "border-box",
                            background: "#ffffff",
                            outline: "none",
                            transition: "border-color 0.2s ease",
                          }}
                          onFocus={(e) => (e.target.style.borderColor = "#60a5fa")}
                          onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
                        />
                      </div>

                      <div style={{ marginBottom: "16px" }}>
                        <label
                          style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "#374151",
                            marginBottom: "6px",
                            display: "block",
                          }}
                        >
                          Comment (Optional)
                        </label>
                        <textarea
                          name='comment'
                          value={bookingData.comment}
                          onChange={handleInputChange}
                          placeholder='Add any special requests...'
                          style={{
                            width: "100%",
                            padding: "10px 12px",
                            border: "1px solid #d1d5db",
                            borderRadius: "8px",
                            fontSize: "14px",
                            minHeight: "80px",
                            boxSizing: "border-box",
                            background: "#ffffff",
                            fontFamily: "inherit",
                            outline: "none",
                            transition: "border-color 0.2s ease",
                            resize: "vertical",
                          }}
                          onFocus={(e) => (e.target.style.borderColor = "#60a5fa")}
                          onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
                        />
                      </div>

                      <div
                        style={{
                          background: "#fef3c7",
                          border: "1px solid #fcd34d",
                          borderRadius: "8px",
                          padding: "12px",
                          marginBottom: "20px",
                          display: "flex",
                          gap: "8px",
                        }}
                      >
                        <span>💡</span>
                        <span style={{ fontSize: "13px", color: "#92400e" }}>Customer can negotiate price via WhatsApp or email</span>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                          position: window.innerWidth <= 800 ? "sticky" : "static",
                          bottom: window.innerWidth <= 800 ? "0" : "auto",
                          background: window.innerWidth <= 800 ? "#ffffff" : "transparent",
                          padding: window.innerWidth <= 800 ? "16px 0 0 0" : "0",
                          borderTop: window.innerWidth <= 800 ? "1px solid #e5e7eb" : "none",
                          marginTop: window.innerWidth <= 800 ? "16px" : "0",
                        }}
                      >
                        <button
                          style={{
                            width: "100%",
                            padding: "12px 20px",
                            background: "#60a5fa",
                            color: "#ffffff",
                            border: "none",
                            borderRadius: "8px",
                            fontSize: "15px",
                            fontWeight: "600",
                            cursor: isFormValid() ? "pointer" : "not-allowed",
                            opacity: isFormValid() ? 1 : 0.5,
                            transition: "all 0.2s ease",
                          }}
                          onClick={shareOnWhatsApp}
                          disabled={!isFormValid()}
                          onMouseEnter={(e) => isFormValid() && (e.target.style.background = "#3b82f6")}
                          onMouseLeave={(e) => (e.target.style.background = "#60a5fa")}
                        >
                          📱 Share on WhatsApp
                        </button>
                        <button
                          style={{
                            width: "100%",
                            padding: "12px 20px",
                            background: "#ffffff",
                            color: "#60a5fa",
                            border: "1px solid #60a5fa",
                            borderRadius: "8px",
                            fontSize: "15px",
                            fontWeight: "600",
                            cursor: isFormValid() ? "pointer" : "not-allowed",
                            opacity: isFormValid() ? 1 : 0.5,
                            transition: "all 0.2s ease",
                          }}
                          onClick={() => {
                            console.log("customer.customerEmail", bookingData.customerEmail);
                            if (!bookingData.customerEmail) {
                              uiAlert("Customer email is required to send booking details via email.", "error");
                              return;
                            }
                            sendToEmail();
                          }}
                          disabled={!isFormValid()}
                          onMouseEnter={(e) => isFormValid() && (e.target.style.background = "#eff6ff")}
                          onMouseLeave={(e) => (e.target.style.background = "#ffffff")}
                        >
                          ✉️ Send to Email
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div
                style={{
                  padding: "60px 40px",
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "28px",
                }}
              >
                <div
                  style={{
                    width: "80px",
                    height: "80px",
                    background: "#60a5fa",
                    borderRadius: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "48px",
                    color: "#ffffff",
                  }}
                >
                  ✓
                </div>
                <h2
                  style={{
                    fontSize: "32px",
                    fontWeight: "700",
                    color: "#60a5fa",
                    margin: 0,
                  }}
                >
                  Order Booked Successfully!
                </h2>
                <button
                  style={{
                    padding: "12px 32px",
                    background: "#60a5fa",
                    color: "#ffffff",
                    border: "none",
                    borderRadius: "8px",
                    fontSize: "15px",
                    fontWeight: "600",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                  }}
                  onClick={resetDemo}
                  onMouseEnter={(e) => (e.target.style.background = "#3b82f6")}
                  onMouseLeave={(e) => (e.target.style.background = "#60a5fa")}
                >
                  Done
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingOverlay;
